<div class="row mos-u-spacer--padding-top-xxxlg">
  <div class="columns medium-4 medium-offset-4">
    <atlas-card [fullWidth]="true" [elevation]="'raised'">
      <atlas-card-header>
        <h3>Msso Bypass Login</h3>
      </atlas-card-header>
      <atlas-card-content>
        <form [formGroup]="form" (keyup.enter)="login()">
          <div class="row mos-o-form-row">
            <div class="small-12 columns mos-o-form-input-field">
              <input [formControl]="form.get('username')" id="username-input" type="text" placeholder="Username">
              <label for="username-input" data-mos-hint-text="Enter Username"></label>
            </div>
          </div>
          <div class="row mos-o-form-row">
            <div class="small-12 columns mos-o-form-input-field">
              <input [formControl]="form.get('password')" id="password-input" type="password" placeholder="Password">
              <label for="password-input" data-mos-hint-text="Enter Password"></label>
            </div>
          </div>
        </form>
      </atlas-card-content>
      <atlas-card-footer>
        <atlas-button-group [style]="'strong'" [color]="'brand'">
          <button #buttonGroup [style.flex]="1" (click)="login()">Continue</button>
        </atlas-button-group>
      </atlas-card-footer>
    </atlas-card>
  </div>
</div>